import React, {Component, Fragment} from 'react';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import DEFINE, {PATHS, FEATURE_FLAGS} from "../../../../constants/Define";
import Ripple from '../../common/component/Ripple';
import RedirectLinkList from './RedirectLinkList';
import { Link } from 'react-router-dom';

let permisionActions = [];

export default class RedirectLink extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.redirectLinkState.pageSize,
                pageIndex: this.props.redirectLinkState.pageIndex,
            }
        }
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.REDIRECT_LINK);
        this.props.getRedirectLinks(this.state.filters);
    }

    render() {
        const {t} = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, redirectLinks } = this.props.redirectLinkState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'redirectlink'}
                        titleHeader={t('navigation.redirectlink')}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={PATHS.REDIRECT_LINK.CREATE.path}
                                          className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <RedirectLinkList loading={isFetching}
                                  permisions={permisionActions}
                                  redirectLinks={redirectLinks}
                                  pagination={pagination}
                                  onChange={this.onTableChange}
                                  onDelete={this.onDeleteRedirectLink}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onChangeLanguage = () => {
        this.props.getRedirectLinks(this.state.filters)
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getRedirectLinks(newFilters);
    }

    onDeleteRedirectLink = (item) => {
        this.props.deleteRedirectLinkDetail(item, {
            filters: {
                pageSize: this.props.redirectLinkState.pageSize,
                pageIndex: this.props.redirectLinkState.pageIndex
            }
        });
    }
}

